import React, { useEffect } from 'react';
import { useChatStore } from '../../hooks/useChatStore';
import { getAvatarEmoji } from './ChatWindow';
import { absUrl } from '../../services/api';
import '../../styles/chat.css';

export default function ChatRequestHandler() {
  const { pendingRequests, fetchChatRequests, acceptChatRequest, declineChatRequest, requestResult, setActiveChat } = useChatStore();
  const [busy, setBusy] = React.useState(false);
  const [dismissed, setDismissed] = React.useState({});

  useEffect(() => {
    fetchChatRequests().catch(() => {});
  }, []);

  const active = pendingRequests.find((r) => !dismissed[r.id]);

  useEffect(() => {
    if (requestResult?.status === 'declined') {
      alert('Пользователь отклонил ваш запрос');
      useChatStore.setState({ requestResult: null });
    } else if (requestResult?.status === 'accepted' && requestResult.chatId) {
      setActiveChat(requestResult.chatId);
      useChatStore.setState({ requestResult: null });
    }
  }, [requestResult]);

  if (!active) return null;

  const requester = active.requester;
  const avatarSrc = requester?.avatarUrl ? absUrl(requester.avatarUrl) : null;

  const handleDecline = async () => {
    setBusy(true);
    try {
      await declineChatRequest(active.id);
      setDismissed((d) => ({ ...d, [active.id]: true }));
    } catch (e) {}
    setBusy(false);
  };

  const handleAccept = async () => {
    setBusy(true);
    try {
      const chat = await acceptChatRequest(active.id);
      setDismissed((d) => ({ ...d, [active.id]: true }));
      setActiveChat(chat.id);
    } catch (e) {}
    setBusy(false);
  };

  return (
    <div className="modal-overlay">
      <div className="modal user-info-modal">
        <div className="user-info-header">
          {avatarSrc ? (
            <img src={avatarSrc} alt="" className="user-info-avatar" />
          ) : (
            <div className="user-info-avatar user-info-avatar-placeholder">
              {getAvatarEmoji(requester?.displayName || requester?.username)}
            </div>
          )}
          <div className="user-info-titles">
            <h3 style={{ margin: 0 }}>{requester?.displayName || requester?.username}</h3>
            <span className="user-info-username">@{requester?.username || ''}</span>
          </div>
        </div>
        <div className="user-info-body">
          <div className="user-info-status">
            Пользователь хочет начать чат с вами
          </div>
          <div className="user-info-actions">
            <button className="user-info-btn" onClick={handleAccept} disabled={busy}>
              {busy ? '...' : '💬 Начать чат'}
            </button>
            <button className="user-info-btn danger" onClick={handleDecline} disabled={busy}>
              {busy ? '...' : 'Отклонить'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}